module.exports = __webpack_public_path__ + "img/icon_card.c29a5d97.png";